import { Users, DollarSign, TrendingUp, BarChart3 } from 'lucide-react';

export const OverviewTab = ({ stats }) => {
  if (!stats) return null;
  return (
    <div className="space-y-6" data-testid="admin-overview-tab">
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
        <div className="bg-white rounded-2xl p-6 shadow-sm border border-slate-100">
          <div className="flex items-center justify-between mb-4">
            <div className="w-12 h-12 rounded-xl bg-blue-100 flex items-center justify-center">
              <Users className="w-6 h-6 text-blue-600" />
            </div>
            <span className="text-xs text-emerald-600 bg-emerald-50 px-2 py-1 rounded-full">
              +{stats.users.recent_signups} this month
            </span>
          </div>
          <p className="text-sm text-slate-500" data-testid="kpi-total-users-label">Total Users</p>
          <p className="font-outfit text-3xl font-bold text-slate-900" data-testid="kpi-total-users">{stats.users.total}</p>
        </div>
        <div className="bg-white rounded-2xl p-6 shadow-sm border border-slate-100">
          <div className="flex items-center justify-between mb-4">
            <div className="w-12 h-12 rounded-xl bg-emerald-100 flex items-center justify-center">
              <DollarSign className="w-6 h-6 text-emerald-600" />
            </div>
          </div>
          <p className="text-sm text-slate-500" data-testid="kpi-monthly-revenue-label">Monthly Revenue</p>
          <p className="font-outfit text-3xl font-bold text-slate-900" data-testid="kpi-monthly-revenue">
            ${stats.revenue.this_month.toLocaleString()}
          </p>
        </div>
        <div className="bg-white rounded-2xl p-6 shadow-sm border border-slate-100">
          <div className="flex items-center justify-between mb-4">
            <div className="w-12 h-12 rounded-xl bg-purple-100 flex items-center justify-center">
              <TrendingUp className="w-6 h-6 text-purple-600" />
            </div>
          </div>
          <p className="text-sm text-slate-500" data-testid="kpi-total-revenue-label">Total Revenue</p>
          <p className="font-outfit text-3xl font-bold text-slate-900" data-testid="kpi-total-revenue">
            ${stats.revenue.total.toLocaleString()}
          </p>
        </div>
        <div className="bg-white rounded-2xl p-6 shadow-sm border border-slate-100">
          <div className="flex items-center justify-between mb-4">
            <div className="w-12 h-12 rounded-xl bg-amber-100 flex items-center justify-center">
              <BarChart3 className="w-6 h-6 text-amber-600" />
            </div>
          </div>
          <p className="text-sm text-slate-500" data-testid="kpi-total-analyses-label">Total Analyses</p>
          <p className="font-outfit text-3xl font-bold text-slate-900" data-testid="kpi-total-analyses">
            {stats.platform.total_analyses.toLocaleString()}
          </p>
        </div>
      </div>
      <div className="bg-white rounded-2xl p-6 shadow-sm border border-slate-100">
        <h3 className="font-outfit text-lg font-semibold text-[#0B3D91] mb-4">Users by Tier</h3>
        <div className="grid sm:grid-cols-4 gap-4" data-testid="users-by-tier-grid">
          {Object.entries(stats.users.by_tier).map(([tier, count]) => (
            <div key={tier} className="text-center p-4 bg-slate-50 rounded-xl" data-testid={`tier-count-${tier}`}>
              <p className="text-2xl font-bold text-slate-900">{count}</p>
              <p className="text-sm text-slate-500 capitalize">{tier}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
